module.exports = __webpack_public_path__ + "static/media/TommyShirt.8f8e51fb.glb";